import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_TITLE = 'Shermo';

const TITLES: Record<string, string> = {
  '/arbitrage/profits': 'Profits',
  '/arbitrage/alerts': 'Alerts',
  '/arbitrage/marked-as-read': 'Marked as read',
  '/arbitrage/cryptos-info': 'Cryptos info',
  '/arbitrage/exchanges-status': 'Exchanges Status',
  '/arbitrage/services-status': 'Services Status',
  '/arbitrage': 'Profits',
  '/config-editor/crypto': 'Crypto Editor',
  '/config-editor': 'Crypto Editor',
  '/assets': 'Asset Catalog',
  '/predictions/opportunities': 'Opportunities',
  '/predictions/positions': 'Positions',
  '/predictions/unwinding': 'Unwinding',
  '/predictions/opening': 'Opening',
  '/predictions/notifications': 'Notifications',
  '/predictions/mapper': 'Prediction Mapper',
  '/predictions/status': 'Predictions Status',
  '/predictions/economics': 'Economics'
};

function resolveTitle(pathname: string): string | null {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (TITLES[normalized]) return TITLES[normalized];
  const prefixes = Object.keys(TITLES).sort((a, b) => b.length - a.length);
  for (const prefix of prefixes) {
    if (normalized === prefix || normalized.startsWith(prefix + '/')) {
      return TITLES[prefix];
    }
  }
  return null;
}

export function usePageTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const name = resolveTitle(pathname);
    document.title = name ? `${name} · ${BASE_TITLE}` : BASE_TITLE;
  }, [pathname]);
}
